import { action } from 'typesafe-actions';
import * as moment from 'moment';
import { Week } from './types';
import { Season } from 'src/store/season/types';
import { WeekActionTypes } from './types';

export const calculateWeeks = (season: Season, seeUpTo?: number) => {
  let startDate;
  let endDate;
  if (seeUpTo) {
    startDate = moment().startOf('isoWeek');
    if (startDate.isBefore(moment(season.startdate).startOf('isoWeek'), 'd')) {
      startDate = moment(season.startdate).startOf('isoWeek');
    }
    endDate = moment()
      .add(seeUpTo, 'd')
      .endOf('isoWeek');
  } else {
    startDate = moment(season.startdate).startOf('isoWeek');
    endDate = moment(season.enddate);
  }

  const weeks: Week[] = [];
  const date = moment(startDate);

  while (date <= moment(endDate).endOf('isoWeek')) {
    const id = '' + moment(date).year() + moment(date).isoWeek();
    const week: Week = {
      id: +id,
      startDate: moment(date).startOf('isoWeek'),
      endDate: moment(date).endOf('isoWeek'),
      open: false,
      events: [],
      weekDays: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: []
      }
    };
    weeks.push(week);

    date.add(1, 'w');
  }
  console.log(weeks);

  return (dispatch: any) => {
    dispatch(action(WeekActionTypes.CALCULATE_WEEKS, { seasonId: season.id, weeks }));

    const current = moment();
    weeks.map((week: Week) => {
      if (current.isSameOrAfter(week.startDate, 'd') && current.isSameOrBefore(week.endDate, 'd')) {
        dispatch(action(WeekActionTypes.TOGGLE_WEEK, { weekId: week.id }));
      }
    });
  };
};

export const toggleWeek = (weekId: number) => {
  return (dispatch: any) => dispatch(action(WeekActionTypes.TOGGLE_WEEK, { weekId }));
};



// WEBPACK FOOTER //
// ./src/store/weeks/actions.ts